// extracted by mini-css-extract-plugin
export default {"container":"AuthFormFooter_container__Ahm1Y","line":"AuthFormFooter_line__FnUH5"};